import React, { useState } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const FeedbackMentor = (props) => {
  const { userdata } = props;
  const { handleSubmit } = useForm();
  const history = useNavigate();
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const onSubmit = (data) => {
    const request = {};
    request.mentee_id = userdata.mentee_id;
    request.mentor_id = userdata.mentor_id;
    request.review = data.review;
    request.user_role = "Mentor";
    agent
      .post(API.LOAD_CUSTOMER + "/updateReview", request)
      .then((res) => {
        setPopupMessage(res.data.message);
        setShowPopup(true);
      })
      .catch((err) => {
        setPopupMessage("Something went wrong.Please try again.");
        setShowPopup(true);
      });
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton>Feedback</Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <p>{userdata.mentor_review}</p>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

        <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false);
          props.onHide();
          history("/mentees-logs");
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

FeedbackMentor.propTypes = {
  userdata: PropTypes.shape({
    mentee_id: PropTypes.number.isRequired,
    mentor_id: PropTypes.number.isRequired,
    mentor_review: PropTypes.string,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
};

export default FeedbackMentor;
